var _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgMath = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 32,
    viewBox: "0 0 109 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H93C101.837 0 109 7.16344 109 16V16C109 24.8366 101.837 32 93 32H16C7.16345 32 0 24.8366 0 16V16Z",
    fill: "#7DACFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 16C4 9.37258 9.37258 4 16 4H24C30.6274 4 36 9.37258 36 16V16C36 22.6274 30.6274 28 24 28H16C9.37258 28 4 22.6274 4 16V16Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.93 21.07V17.935H51.93V16.915H54.93V13.78H56.07V16.915H59.07V17.935H56.07V21.07H54.93Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73 16C73 9.37258 78.3726 4 85 4H93C99.6274 4 105 9.37258 105 16V16C105 22.6274 99.6274 28 93 28H85C78.3726 28 73 22.6274 73 16V16Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 1H93V-1H16V1ZM93 31H16V33H93V31ZM16 31C7.71573 31 1 24.2843 1 16H-1C-1 25.3888 6.61116 33 16 33V31ZM108 16C108 24.2843 101.284 31 93 31V33C102.389 33 110 25.3888 110 16H108ZM93 1C101.284 1 108 7.71573 108 16H110C110 6.61116 102.389 -1 93 -1V1ZM16 -1C6.61116 -1 -1 6.61116 -1 16H1C1 7.71573 7.71573 1 16 1V-1Z",
    fill: "black",
    fillOpacity: 0.1
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMath, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/math.d22b7c78.svg";
export { ForwardRef as ReactComponent };